import { useEffect, useState } from "react";

// export default function useWindowWidth() {
//   const [width, setWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     window.addEventListener("resize", function () {
//       setWidth(window.innerWidth);
//     });
//   }, []);

//   return width;
// }

// function useOnlineStatus() {
//   const [statusnow, setStatusnow] = useState(false);

//   useEffect(() => {
//     function testcase() {
//       setStatusnow(navigator.onLine);
//     }
//     window.addEventListener("online", testcase);
//     return () => window.removeEventListener(testcase);
//   }, [statusnow]);

//   return statusnow;
// }

// export default useOnlineStatus;

function useDocumentTitle(val) {
  document.title = val;
}

export default useDocumentTitle;
